import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Injectable, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BehaviorSubject, Observable, of as observableOf } from 'rxjs';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { TestsService } from 'src/app/core/services/tests.service';
import { SelectionModel } from '@angular/cdk/collections';


/**
 * Entity node data with nested structure.
 * Each node has a name, and a type or a list of children.
 */
export class EntityNode {
  children!: EntityNode[];
  name!: string;
  id?: string;
}

/** Flat node with expandable and level information */
export class EntityFlatNode {
  constructor(
    public expandable: boolean, public name: string, public level: number, public id: any) { }
}

/**
 * The entity structure tree data in string. The data could be parsed into a Json object
 */


@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements AfterViewInit {
  treeControl: FlatTreeControl<EntityFlatNode>;
  treeFlattener: MatTreeFlattener<EntityNode, EntityFlatNode>;
  dataSource: MatTreeFlatDataSource<EntityNode, EntityFlatNode>;
  /*fullDatasource = [
    ...something, ...something, ...something,
    ...something, ...something, ...something,
    ...something, ...something, ...something,
  ].map((item, index) => { return { ...item, filename: 'this is item ' + index } })*/
  fullDatasource = [];
  @ViewChild(CdkVirtualScrollViewport) virtualScroll!: CdkVirtualScrollViewport;

  selection = new SelectionModel<any>(true, []);
  selectedIds = new Set<string>(); // Store selected node IDs persistently
  expandedNodes = new Set<string>(); // Track expanded nodes by their IDs


  constructor(private jerarquiaService: TestsService, private cdr: ChangeDetectorRef) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this._getLevel, this._isExpandable, this._getChildren);
    this.treeControl = new FlatTreeControl<EntityFlatNode>(this._getLevel, this._isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = this.fullDatasource.slice(0, 3);
  }

  transformer = (node: EntityNode, level: number) => {
    return new EntityFlatNode(!!node.children && node.children.length > 0, node.name, level,node.id);
  }

  private _getLevel = (node: EntityFlatNode) => node.level;

  private _isExpandable = (node: EntityFlatNode) => node.expandable;

  private _getChildren = (node: EntityNode): Observable<EntityNode[]> => observableOf(node.children);

  hasChild = (_: number, _nodeData: EntityFlatNode) => _nodeData.expandable;

  ngAfterViewInit() {
    const url = 'assets/data/3000clients.json'; // Replace with actual URL
    this.jerarquiaService.obtenerYJerarquizarJson(url).subscribe(
      (data) => {
        this.fullDatasource = data.map((item: any, index: string) => ({
          ...item, name: item.name + index
        }));

        this.virtualScroll.renderedRangeStream.subscribe(range => {
          console.log(range, 'range');

          // Get currently visible nodes
          const currentVisibleNodes = this.fullDatasource.slice(range.start, range.end);
          this.dataSource.data = currentVisibleNodes;

          // Clear selection before restoring to prevent duplicates
          this.selection.clear();

          // Restore selection for visible nodes if they were previously selected
          currentVisibleNodes.forEach((node: any) => {
            if (this.selectedIds.has(node.id)) {
              this.selection.select(node);
            };
            console.log(this.expandedNodes);
            // Reapply expanded state for the node
            if (this.expandedNodes.has(node.id)) {
              console.log(node);
              this.treeControl.expand(node);
              //this.treeControl.expandAll();
              console.log(this.treeControl.isExpandable(node));
              console.log(this.treeControl.isExpanded(node));
            };
          });

          // Manually trigger UI update
          this.cdr.detectChanges();
        });
      },
      (error) => {
        console.error('Error al obtener el JSON', error);
      }
    );
  }

  isSelected(node: EntityFlatNode): boolean {
    return this.selectedIds.has(node.id);
  }

  toggleSelection(node: EntityFlatNode): void {
    // Update selectedIds and selection model accordingly
    if (this.selectedIds.has(node.id)) {
      // Deselect the node
      this.selectedIds.delete(node.id);
      this.selection.deselect(node);
    } else {
      // Select the node
      this.selectedIds.add(node.id);
      this.selection.select(node);
    }

    // Manually trigger UI update when selection changes
    this.cdr.detectChanges();

    // 🔄 Debugging: Log current selection IDs
    console.log('Updated selectedIds:', Array.from(this.selectedIds));
    console.log('Selection model:', this.selection.selected);
  }

  toggleExpand(node: EntityFlatNode): void {
    if (this.treeControl.isExpanded(node)) {
      // If the node is expanded, collapse it
      this.treeControl.collapse(node);
      this.expandedNodes.delete(node.id); // Remove it from the expanded set
    } else {
      // If the node is collapsed, expand it
      this.treeControl.expand(node);
      this.expandedNodes.add(node.id); // Add it to the expanded set
    }

    // Manually trigger UI update when expansion state changes
    this.cdr.detectChanges();

    console.log('Expanded nodes:', Array.from(this.expandedNodes));
  }
}